<template>
  <td>
    <div v-if="content === true">
      <i class="fa fa-check" />
    </div>
    <i v-else />
  </td>
</template>

<script lang="babel">
export default {
    props: ['content', 'label', 'model']
};
</script>
